import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';

export function Modal({
  open,
  onClose,
  disableEscapeKeyDown = false,
  children,
}: {
  disableEscapeKeyDown?: boolean;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={onClose}
      onEscapeKeyDown={
        disableEscapeKeyDown
          ? (event) => {
              event.preventDefault();
            }
          : null
      }
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 bg-black/50 z-49" />
        <DialogPrimitive.Content className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-4 shadow-lg focus:outline-none">
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
